/*
This intends to be a lazy tooltip component, which wouldn't run any
reactstrap tooltip code until user hover over the target
*/

import React, {
  cloneElement,
  ReactElement,
  ReactNode,
  useRef,
  useState,
} from 'react';

import {UncontrolledTooltip} from 'reactstrap';

import type {OverlayPlacementType} from 'app/general/overlays';

type Props = {
  className?: string;
  delay?: number | {show: number; hide: number};
  hide?: boolean;
  tooltip?: ReactNode;
  children: ReactElement;
  placement?: OverlayPlacementType;
};

export function LazyTooltip({
  hide = false,
  children,
  tooltip,
  delay = 250,
  ...other
}: Props): JSX.Element {
  const [mounted, setMounted] = useState(false);

  const childrenRef = useRef<HTMLElement | null>(null);

  return (
    <>
      {cloneElement(children, {
        ref: childrenRef,
        onMouseEnter: () => setMounted(true),
      })}
      {tooltip != null && !hide && mounted ? (
        <UncontrolledTooltip
          className="fade in out"
          autohide={false}
          target={childrenRef}
          delay={delay}
          {...other}
        >
          {tooltip}
        </UncontrolledTooltip>
      ) : null}
    </>
  );
}
